import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, LinearProgress, Typography } from '@mui/material';
import axiosInstance from '../utills/axiosInstance';
import moment from 'moment';

const LeaveBalance = () => {
    const [balances, setBalances] = useState([]);

    useEffect(() => {
        const profile = JSON.parse(localStorage.getItem('profile'));
        axiosInstance.get(`/api/leave/balance/${profile._id}`).then(res => setBalances(res?.data));
    }, []);

    return (
        <Paper sx={{ p: 2, m: 2 }}>
            <Typography variant="h5" textAlign="center" mb={4}>
                Leave Balance
            </Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Leave Type</TableCell>
                            <TableCell>Opening</TableCell>
                            <TableCell>Credited</TableCell>
                            <TableCell>Used</TableCell>
                            <TableCell>Available</TableCell>
                            <TableCell>Carry Forward</TableCell>
                            <TableCell>Expiry</TableCell>
                            <TableCell>Usage</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {balances?.map((bal) => (
                            <TableRow key={bal._id}>
                                <TableCell>{bal.leaveType.name}</TableCell>
                                <TableCell>{bal.openingBalance}</TableCell>
                                <TableCell>{bal.credited}</TableCell>
                                <TableCell>{bal.used}</TableCell>
                                <TableCell>{bal.available}</TableCell>
                                <TableCell>{bal.carryForward}</TableCell>
                                <TableCell>{moment(bal.expiryDate).format('DD/MM/YYYY')}</TableCell>
                                <TableCell>
                                    <LinearProgress variant="determinate" value={(bal.used / (bal.openingBalance + bal.credited)) * 100} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default LeaveBalance;
